var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseToolsCalculators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8182 5H9.18182C7.97683 5 7 5.99492 7 7.22222V22.7778C7 24.0051 7.97683 25 9.18182 25H20.8182C22.0232 25 23 24.0051 23 22.7778V7.22222C23 5.99492 22.0232 5 20.8182 5Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.07123H10.5C10.2239 8.07123 10 8.20554 10 8.37123V9.77123C10 9.93691 10.2239 10.0712 10.5 10.0712H19.5C19.7761 10.0712 20 9.93691 20 9.77123V8.37123C20 8.20554 19.7761 8.07123 19.5 8.07123Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0339 12.0712H10.1777C9.92139 12.0712 9.71362 12.2908 9.71362 12.5616V14.5229C9.71362 14.7937 9.92139 15.0133 10.1777 15.0133H12.0339C12.2902 15.0133 12.4979 14.7937 12.4979 14.5229V12.5616C12.4979 12.2908 12.2902 12.0712 12.0339 12.0712Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7458 12.0712H13.8896C13.6333 12.0712 13.4255 12.2908 13.4255 12.5616V14.5229C13.4255 14.7937 13.6333 15.0133 13.8896 15.0133H15.7458C16.0021 15.0133 16.2099 14.7937 16.2099 14.5229V12.5616C16.2099 12.2908 16.0021 12.0712 15.7458 12.0712Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4592 12.0712H17.603C17.3467 12.0712 17.1389 12.2908 17.1389 12.5616V14.5229C17.1389 14.7937 17.3467 15.0133 17.603 15.0133H19.4592C19.7155 15.0133 19.9232 14.7937 19.9232 14.5229V12.5616C19.9232 12.2908 19.7155 12.0712 19.4592 12.0712Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0339 15.9941H10.1777C9.92139 15.9941 9.71362 16.2137 9.71362 16.4845V18.4458C9.71362 18.7167 9.92139 18.9362 10.1777 18.9362H12.0339C12.2902 18.9362 12.4979 18.7167 12.4979 18.4458V16.4845C12.4979 16.2137 12.2902 15.9941 12.0339 15.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7458 15.9941H13.8896C13.6333 15.9941 13.4255 16.2137 13.4255 16.4845V18.4458C13.4255 18.7167 13.6333 18.9362 13.8896 18.9362H15.7458C16.0021 18.9362 16.2099 18.7167 16.2099 18.4458V16.4845C16.2099 16.2137 16.0021 15.9941 15.7458 15.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4592 15.9941H17.603C17.3467 15.9941 17.1389 16.2137 17.1389 16.4845V18.4458C17.1389 18.7167 17.3467 18.9362 17.603 18.9362H19.4592C19.7155 18.9362 19.9232 18.7167 19.9232 18.4458V16.4845C19.9232 16.2137 19.7155 15.9941 19.4592 15.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0339 19.917H10.1777C9.92139 19.917 9.71362 20.1365 9.71362 20.4073V22.3687C9.71362 22.6395 9.92139 22.859 10.1777 22.859H12.0339C12.2902 22.859 12.4979 22.6395 12.4979 22.3687V20.4073C12.4979 20.1365 12.2902 19.917 12.0339 19.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7458 19.917H13.8896C13.6333 19.917 13.4255 20.1365 13.4255 20.4073V22.3687C13.4255 22.6395 13.6333 22.859 13.8896 22.859H15.7458C16.0021 22.859 16.2099 22.6395 16.2099 22.3687V20.4073C16.2099 20.1365 16.0021 19.917 15.7458 19.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4592 19.917H17.603C17.3467 19.917 17.1389 20.1365 17.1389 20.4073V22.3687C17.1389 22.6395 17.3467 22.859 17.603 22.859H19.4592C19.7155 22.859 19.9232 22.6395 19.9232 22.3687V20.4073C19.9232 20.1365 19.7155 19.917 19.4592 19.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseToolsCalculators);
export default __webpack_public_path__ + "static/media/CollapseToolsCalculators.a83a831d01abed625b3533161742c55c.svg";
export { ForwardRef as ReactComponent };